export default function InternalGreenCheckIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M10.958 4.95996C11.3485 4.56949 11.9815 4.5696 12.3721 4.95996C12.7626 5.35049 12.7626 5.9835 12.3721 6.37402L7.70605 11.041C7.31564 11.4314 6.68254 11.4312 6.29199 11.041L3.625 8.37402C3.23448 7.9835 3.23448 7.35049 3.625 6.95996C4.01552 6.56944 4.64854 6.56944 5.03906 6.95996L6.99805 8.91895L10.958 4.95996Z"
                fill="#85E0A3"
                stroke="#85E0A3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
